import { useEffect, useState } from 'react';
import { goApi } from '../services';
import { apiRoutes } from '../services/apiRoutes';

type UseFetchVideoStatProps = {
    videoId: string;
    page?: number;
    perPage?: number;
};

const useFetchVideoStat = ({ videoId, page = 1, perPage = 20 }: UseFetchVideoStatProps) => {
    const [videoStat, setVideoStat] = useState<any[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchVideoStat = async () => {
        try {
            setLoading(true);

            const data = await goApi.get(apiRoutes.VIDEO_STATS(videoId, page, perPage));

            setVideoStat(data?.data.items || []);
            setTotal(data?.data.pagination.total || 0);
        } catch (err: any) {
            setError(err.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (videoId) {
            fetchVideoStat();
        }
    }, [videoId, page, perPage]);

    return { videoStat, total, loading, error };
};

export default useFetchVideoStat;
